import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ISort} from "../../../../interfaces/sort";
import {ISortHeader} from "../../../../interfaces/table-header";

@Component({
  selector: 'smart-table-sort',
  templateUrl: './smart-table-sort.component.html'
})
export class SmartTableSortComponent implements OnInit {

  @Input('active') set active$(value: ISort) {
    if (!value || !(this.item && this.item.key)) return;

    if (this.current && (value.key !== this.item.key))
      this.current.direction = 0;
  }

  @Input() item: ISortHeader;

  @Output() activeChange: EventEmitter<ISort> = new EventEmitter<ISort>();
  @Output() update: EventEmitter<any> = new EventEmitter<any>();

  current: ISort;

  generator: any;

  *generateSort(start?) {
    if (!start) yield 1;
    if (start == 1 || !start) yield -1;
    return 0;
  }

  constructor() { }

  ngOnInit() {
    this.current = {
      key: this.item.key,
      direction: 0,
    }
  }

  sort() {
    if (!this.current.direction) this.generator = this.generateSort();
    this.current.direction = this.generator.next().value;

    this.setActive();
  }

  setActive(update: boolean = true) {

    this.activeChange.emit(this.current.direction ? this.current : null);

    if (update)
      this.update.emit();
  }
}
